import script from "./DpSpacesHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./DpSpacesHeader.vue?vue&type=script&setup=true&lang=ts"

import "./DpSpacesHeader.vue?vue&type=style&index=0&id=9238b83a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9238b83a"]])

export default __exports__